const RhombusIcon = (props) => {
    return (
        <svg
          width={24}
          height={24}
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          {...props}
        >
          <path
            d="M7.36 5.94L10.8 2.5c.7-.7 1.7-.7 2.4 0l3.44 3.44L12 10.59 7.36 5.94zm10.7 1.42L13.41 12l4.65 4.64 3.44-3.44c.6-.7.6-1.7 0-2.4l-3.44-3.44zM5.94 16.64L10.59 12 5.94 7.36 2.5 10.8c-.7.7-.7 1.7 0 2.4l3.44 3.44zM12 13.41l-4.64 4.65 3.44 3.44c.7.7 1.7.7 2.4 0l3.44-3.44L12 13.41z"
            fill="#DFB342"
          />
        </svg>
      )
}

export default RhombusIcon